export default __webpack_public_path__ + "static/media/demo-image.a0244f04.png";